import React from "react";
import { Card, CardContent, Typography, List, ListItem, ListItemText, Divider } from "@mui/material";
import { formatDateTime } from "../utils";

export const RegistroAccionesCard = ({ acciones }) => {
  if (!acciones || acciones.length === 0) {
    return null; // No renderiza nada si no hay acciones
  }

  return (
    <Card sx={{ minWidth: '100%',   boxShadow: 1 }}>
      <CardContent sx={{ p: 1 }}>
        <Typography variant="subtitle2" fontWeight="bold" align="center" gutterBottom>
          Historial de acciones
        </Typography>
        <List dense sx={{overflow: "auto", maxHeight: "22vh"}}>
          {acciones.map((accion, index) => (
            <React.Fragment key={index}>
              <ListItem sx={{ py: 0.5 }}>
                <ListItemText
                  primary={
                    <Typography variant="caption">
                      <strong>{accion.nombre_usuario}</strong> → {accion.accion}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="textSecondary">
                      {formatDateTime(accion.fecha)}
                    </Typography>
                  }
                />
              </ListItem>
              {index < acciones.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
